import { useState } from "react";
import "./styles.css";
import { createUser } from "../../../controller/usersController";
import { TankDataProps } from "../../../controller/tankController";

interface AddUserProps {
  showAddUser: boolean;
  setShowAddUser: (value: boolean) => void;
  availableTanks: TankDataProps[];
}

function AddUser({
  showAddUser,
  setShowAddUser,
  availableTanks,
}: AddUserProps) {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [assignedTank, setAssignedTank] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleAddUser = async () => {
    setIsLoading(true);

    if (assignedTank === null) {
      alert("Assigned tank is required.");
      setIsLoading(false);
      return;
    }

    const userInfo = {
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber,
      email: email,
      address: address,
      assignedTank: assignedTank,
    };

    try {
      const response = await createUser(userInfo);
      const { data } = response;
      if (data && data?.result) {
        alert("User Added Successfully");
        console.log("added user:", data?.result);
      }
      setIsLoading(false);
    } catch (error) {
      alert("Unable to add user");
      setIsLoading(false);
    }
  };

  return (
    <div className="bin-details-wrapper">
      <div className="bin-details">
        <h2 className="bin-details-heading">New User Registration</h2>
        <div className="bin-reg-form">
          <label>
            First Name
            <input
              type="text"
              placeholder="Enter first name"
              className="reg-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </label>
          <label>
            Last Name
            <input
              type="text"
              placeholder="Enter Last Name"
              className="reg-input"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </label>
          <label>
            Phone Number
            <input
              type="number"
              placeholder="Enter phone number"
              className="reg-input"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              maxLength={11}
            />
          </label>
          <label>
            Email
            <input
              type="email"
              placeholder="Enter email address"
              className="reg-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Address
            <input
              type="text"
              placeholder="Enter contact address"
              className="reg-input"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </label>
          <label>
            Assigned Tank
            <select
              className="reg-input"
              value={assignedTank || ""}
              onChange={(e) => setAssignedTank(e.target.value)}
            >
              <option value="" disabled>
                Select Tank
              </option>
              {availableTanks.map((data, index) => (
                <option key={index} value={data.tankUniqueId}>
                  {data.tankUniqueId} (Volume-{data.tankVolume})
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="save-cancel-btn">
          <button
            className="save-btn"
            disabled={isLoading}
            onClick={handleAddUser}
          >
            Save
          </button>
          <button
            className="cancel-btn"
            onClick={() => setShowAddUser(!showAddUser)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddUser;
